import { instance2 } from "App/constants";

import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { isNull, today } from "App/utils/helpers";
export const urlCreatePaket = "/mobile/tarif/add-paket-header";
export const urlUpdatePaket = "/mobile/tarif/update-paket-header";
export const urlCreateDetailPaket = "/mobile/tarif/add-paket-detail";
export const urlUpdateDetailPaket = "/mobile/tarif/update-paket-detail";
export const urlDeleteDetailPaket = "/mobile/tarif/delete-paket-detail";

export const urlGetByID = "/mobile/tarif/list-paket-id";

export const STYLE_MASTER_FA = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
});

export const FORM_RESET_STATE_PAKET_TELE = {
  id: "",
  code: "",
  nama: "",
  diskon: "",
  total_diskon2: "",
  tax: "",
  total_tax: "",
  total_tax2: "",
  biaya_lain: "",
  biaya_lain2: "",
  tanggal_start: today(),
  tanggal_expired: today(),
  status: "",
  status_nama: "Pilih Status",
  remark: "",
};

export const FORM_RESET_DETAIL_PAKET = {
  id: "",
  paket_tarif_tele_header_id: "",
  id_dokter: "",
  dokter: "Pilih Dokter",
  remark: "",
};

// export const getReqById = async (id) => {
//   try {
//     const api = await instance4.get(`${urlGetByID}/${id}`);
//     const res = api.data;
//     if (res.status === 200) {
//       return {
//         state: true,
//         data:
//           res.data.length > 0
//             ? res.data[0]
//             : {
//                 totalTax: 0,
//                 jumlah: 0,
//               },
//       };
//     } else {
//       return {
//         state: false,
//         message: res.message,
//       };
//     }
//   } catch (error) {
//     return {
//       state: false,
//       message: error?.response?.data?.message,
//     };
//   }
// };

export const createHeader = async (formData) => {
  const api = await instance2.post(urlCreatePaket, {
    code: formData.code,
    nama: formData.nama,
    diskon: isNull(formData.diskon) ? 0 : parseFloat(formData.diskon),
    total_diskon: isNull(formData.total_diskon) ? 0 : formData.total_diskon,
    tax: isNull(formData.tax) ? 0 : parseFloat(formData.tax),
    total_tax: isNull(formData.total_tax) ? 0 : formData.total_tax,
    tanggal_start: moment(formData.tanggal_start).format("YYYY-MM-DD"),
    tanggal_expired: moment(formData.tanggal_expired).format("YYYY-MM-DD"),
    biaya_lain: isNull(formData.biaya_lain) ? 0 : formData.biaya_lain,
    status: formData.status,
    remark: formData.remark,
  });
  return api;
};

export const updateHeader = async (formData) => {
  const api = await instance2.post(urlUpdatePaket, {
    code: formData.code,
    nama: formData.nama,
    diskon: isNull(formData.diskon) ? 0 : parseFloat(formData.diskon),
    total_diskon: isNull(formData.total_diskon) ? 0 : formData.total_diskon,
    tax: isNull(formData.tax) ? 0 : parseFloat(formData.tax),
    total_tax: isNull(formData.total_tax) ? 0 : formData.total_tax,
    tanggal_start: moment(formData.tanggal_start).format("YYYY-MM-DD"),
    tanggal_expired: moment(formData.tanggal_expired).format("YYYY-MM-DD"),
    biaya_lain: isNull(formData.biaya_lain) ? 0 : formData.biaya_lain,
    status: formData.status,
    remark: formData.remark,
    id: formData.id,
  });
  return api;
};

export const getPaketListById = async (id) => {
  try {
    const api = await instance2.get(`${urlGetByID}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        detail: res.data.detail,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteDetailListById = async (id) => {
  try {
    const api = await instance2.post(urlDeleteDetailPaket, {
      id,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res,
        message: "Berhasil menghapus detail paket",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "left",
  },
  {
    id: "dokter",
    disablePadding: false,
    label: "NAMA DOKTER",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    minWidth: "200px",
  },
];
